import WebFont from 'webfontloader';

const WebFonts = {
  init() {
    const config = {
      typekit: {
        id: 'qpf6syz'
      }
    };

    WebFont.load(config);
  }
};

export default WebFonts;



// WEBPACK FOOTER //
// ./src/client/WebFonts.js